import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedCompanyMyNotaryApiService } from './company-my-notary-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyMyNotaryApiService extends GeneratedCompanyMyNotaryApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
